import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductChangePackagesDataGrid } from "src/components/views/erp/productChanges/masterData/ProductChangePackagesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/productChangePackages")({
	staticData: { title: i18n.t("product_change_packages"), legacyViewKey: "productChangePackagesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductChangePackagesDataGrid />;
}
